import {
  HabitatIntactnessAndThreats,
  LayerFactValue,
  MAP_LAYER_FACTS,
  MapRastersFact,
  RasterLayerYear,
} from '@/api/rest/resources/types/fact';
import { usePlotFacts } from '@/pages/shared/hooks/usePlotFact';
import { getFactFromFactArray } from '@/pages/shared/hooks/utils';
import {
  InteractiveMapFormFields,
  useInteractiveMapControlsContext,
} from '@/pages/shared/plots/pages/hooks/useControlsForm';

export const MAP_RASTERS_FACT = MAP_LAYER_FACTS.habitat_intactness_raster_urls;
export const WMS_PARAMS =
  '&styles=&bbox={bbox-epsg-3857}&width=256&height=256&srs=EPSG:3857&format=image/png&transparent=true'; // Append required WMS parameters for MapBox GL JS raster tile source

export const useLayerUrl = (layer: HabitatIntactnessAndThreats): string | null => {
  const plotFacts = usePlotFacts<MapRastersFact>([MAP_RASTERS_FACT]);
  const urls = getFactFromFactArray<LayerFactValue>(plotFacts, MAP_RASTERS_FACT)?.value;

  const controlsForm = useInteractiveMapControlsContext();
  const year = controlsForm.watch(InteractiveMapFormFields.Year) as RasterLayerYear;

  const layerRasterData = urls?.[`${layer}`]?.[`${year}`];

  if (!layerRasterData || !layerRasterData.map_url) {
    return null;
  }

  return `${layerRasterData.map_url}${WMS_PARAMS}`;
};
